<template>
  <div class="container-fluid">
    <div class="row" v-if="highscoreLookupError !== null">
      <div class="col-12">
        <div class="alert alert-warning">
          Highscore lookup is currently having issues, please use manual stat entry!
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 mb-3">
        <h1 class="text-center">OSRS DPS Calculator</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">

        <div class="row">
          <div class="col-xl-6 col-sm-12 mb-0">
            <PlayerLookup :player="player"
                          @lookup="(newPlayer) => {this.player = newPlayer}"></PlayerLookup>

          </div>
          <div class="col-xl-6 col-sm-12">
            <div class="card">
              <div class="card-body">
                <MonsterLookup :monster="monster" @hit="monsterSelected"></MonsterLookup>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <GearCompare :monster="monster" :player="player" class="col-xl-12"></GearCompare>
        </div>
      </div>

    </div>


    <div class="row mt-2 mb-2">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <InArticleAdsense
              style="display:block; text-align:center;"
              data-ad-layout="in-article"
              data-ad-format="fluid"
              data-ad-client="ca-pub-6075100011305267"
              data-ad-slot="3433025857"
              :is-non-personalized-ads="false"
              :data-full-width-responsive="true">
            </InArticleAdsense>
          </div>
        </div>
      </div>
    </div>


    <div class="row mt-2 mb-2">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">Tool Made Possible By</h5>
            <SponsorContainer></SponsorContainer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PlayerLookup from "../components/PlayerLookup";
  import MonsterLookup from "../components/MonsterLookup";
  import InventoryContainer from "../components/InventoryContainer";
  import GearCompare from "../components/GearCompare";
  import EquipmentBonus from "../components/gear-selector/EquipmentBonus";
  import MonsterBonus from "../components/gear-selector/MonsterBonus";
  import PlayerStats from "../components/PlayerStats";
  import Sponsor from "../components/Sponsor";
  import SponsorContainer from "../components/SponsorContainer";

  export default {
    name: 'DPSCalc',
    components: {
      SponsorContainer,
      Sponsor,
      PlayerStats,
      EquipmentBonus,
      GearCompare,
      MonsterBonus,
      InventoryContainer,
      MonsterLookup,
      PlayerLookup
    },
    data() {
      return {
        highscoreLookupError: null,
        items: [],
        player: {
          onTask: false,
          isDefault: true,
          attack: {level: 99},
          strength: {level: 99},
          defence: {level: 99},
          ranged: {level: 99},
          prayer: {level: 99},
          magic: {level: 99},
          hitpoints: {level: 99},
          combat: {level: 99},
        },
        monster: {
          "id": 1337331,
          "name": "Combat Dummy",
          "incomplete": false,
          "members": false,
          "release_date": "2020-01-01",
          "combat_level": 1337,
          "size": 3,
          "hitpoints": 10000,
          "max_hit": 1,
          "attack_type": ["crush"],
          "attack_speed": 4,
          "aggressive": false,
          "poisonous": false,
          "immune_poison": false,
          "immune_venom": false,
          "attributes": [],
          "category": ["custom"],
          "slayer_monster": true,
          "slayer_level": 1,
          "slayer_xp": 1,
          "slayer_masters": [],
          "duplicate": false,
          "examine": "This dummy is very susceptible to any sort of combat, and functions as any slayer task.",
          "icon": null,
          "wiki_name": "Combat Dummy",
          "wiki_url": "https://oldschool.runescape.wiki/w/Undead_combat_dummy",
          "attack_level": 1,
          "strength_level": 1,
          "defence_level": 1,
          "magic_level": 1,
          "ranged_level": 1,
          "attack_stab": 0,
          "attack_slash": 0,
          "attack_crush": 0,
          "attack_magic": 0,
          "attack_ranged": 0,
          "defence_stab": 0,
          "defence_slash": 0,
          "defence_crush": 0,
          "defence_magic": 0,
          "defence_ranged": 0,
          "attack_accuracy": 0,
          "melee_strength": 0,
          "ranged_strength": 0,
          "magic_damage": 0,
        },
      }
    },
    methods: {
      getItems: function () {
        this.$http.get('https://www.osrsbox.com/osrsbox-db/items-search.json').then((resp) => {
          this.items = resp.data;
        })
      },
      monsterSelected: function (monster) {
        this.monster = monster;
      },

      loadLocalStorage: function () {
        let monster = localStorage.getItem("osrs:compare:monster");
        if (monster !== null) {
          this.monsterSelected(JSON.parse(monster))
        }

      }
    },
    mounted() {
      this.loadLocalStorage()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/DPSCalc.vue